export default __webpack_public_path__ + "static/media/WHITEPAPER.ea1fcfca.png";